import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';
import { useEffect } from 'react';

import { FINISH_RESUME } from 'src/components/Router';

import { CreateResumeBlueCard } from '../CreateResumeBlueCard/CreateResumeBlueCard';
import { setRouteAsTouched } from '../actionCreators';
import { FinishResume as FinishResumeSvg } from '../svg/FinishResume';

import translations from './.vocab';

export const FinishResume = () => {
  const { t } = useTranslations(translations);

  useEffect(() => {
    setRouteAsTouched(FINISH_RESUME);
  });

  return (
    <CreateResumeBlueCard
      heading={t('Click and create')}
      svg={<FinishResumeSvg />}
      data-automation="finish-resume-card"
    >
      <Text size="large" component="p">
        {t('Your resumé will be created and added to your profile.')}
      </Text>
    </CreateResumeBlueCard>
  );
};
